<template>
<div class="panel stock-list">
  <div class="panel-heading text-force-align">
    <div class="text-right">
      過去のいいね一覧
    </div>
    <div class="text-left" v-if="is_show_edit_button">
      <b-icon icon="cog" style="margin-left:1em;"
        v-bind:type="{'is-danger': is_edit}"
        @click.native="is_edit = !is_edit; is_sort = false;">
      </b-icon>
    </div>
  </div>
  <router-link class="panel-block text-force-align"
    v-for="lst in favlog" :key="lst.month"
    :to="(is_edit || is_sort) ? '' : '/likes/'+lst.url">
    <div class="text-right">
      <b-icon icon="book" size="is-small" type="is-danger"></b-icon>
      {{lst.month}}
      <span class="is-size-7 has-text-grey-light" style="padding-left:1em;">
        {{lst.tweet_num}}件のツイート
      </span>
    </div>
    <p class="text-left">
      <a class="button is-rounded is-small is-success" style="margin-right:0.5em;" v-if="is_edit"
         @click="updateMonthTweets(lst.month)">
        <b-icon icon="refresh" size="is-small"></b-icon>
      </a>
    </p>
  </router-link>
  <b-button style="margin-top:1em;" type="is-success" @click="updateLastTweets"
            v-if="is_show_edit_button" expanded :loading="isLoading">
    もっと昔のいいねを取得する
  </b-button>
</div>
</template>

<script>
import {getFavDiscriptFileFromGCS, updateFavlist,
        getInitFavUpdateInfo} from '@/util/favlog_util.js'


export default {
  title: "- 過去のいいね",
  props: {
    is_show_edit_button: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      favlog: [
        {"month":"2020/09", "file":"favlog/hoge_fav202009.json", "tweet_num":48,
         "latest_tweetid":"1304748035776233472", "oldest_tweetid":"1300621900813496320",
         "url":"202009"}
      ],
      is_sort: false,
      is_edit: false,
      isLoading: false,
    }
  },
  computed: {
    user_info() {
      let ret_info = this.$store.getters['getUserInfo']
      return JSON.parse(JSON.stringify(ret_info))
    },
    firebase_uid() {
      return this.user_info.firebase_uid
    }
  },
  mounted() {
    this.getFavDiscriptFile().then((discriptObj) => {
      // 毎回アクセス時に自動更新する
      const initInfo = getInitFavUpdateInfo(discriptObj)
      if(initInfo.needUpdate == false) return
      this.updateFavlistWithApi(initInfo.maxId, initInfo.minId, 10)
    })
  },
  methods: {
    async getFavDiscriptFile() {
      const discriptObj = await getFavDiscriptFileFromGCS(this.firebase_uid)
      if("favlogs" in discriptObj){
        const tmp_favlog = discriptObj.favlogs.map((m) => {
          m.url = m.month.replace("/", "")
          return m
        })
        this.favlog = tmp_favlog.sort((a, b) => {
          if(a.month > b.month) return -1
          else return 1
        })
      }
      return discriptObj
    },
    async updateFavlistWithApi(maxId="", minId="0", getFuncNum=70) {
      this.isLoading = true
      this.$buefy.toast.open({
        message: 'ツイートの取得には時間がかかります<br>しばらくお待ちください',
        type: 'is-success'
      })
      const res = await updateFavlist(this.firebase_uid, this.user_info.access_token,
                                      this.user_info.access_token_secret,
                                      maxId, minId, getFuncNum)
      this.isLoading = false
      this.getFavDiscriptFile()
      return res
    },
    updateLastTweets() {
      const oldestTweetId = this.favlog[this.favlog.length-1].oldest_tweetid
      this.updateFavlistWithApi(oldestTweetId, "0", 10)
    },
    updateMonthTweets(month) {
      const idx = this.favlog.findIndex((fav) => fav.month === month)
      const oldestTweetId = idx>0 ? this.favlog[idx].oldest_tweetid: ""
      this.updateFavlistWithApi(oldestTweetId, "0", 10)
    }
  }
}
</script>

<style scoped>
.stock-list { max-width: 800px;}

@media screen and (min-width: 1100px){
  .stock-list{ 
    max-width: 800px;
    margin-top: 20px;
  }
}

.text-force-align { display: table; width: 100%;}
.text-right { display: table-cell; text-align: left; }
.text-center  { display: table-cell; text-align: center; }
.text-left     { display: table-cell; text-align: right; }
</style>